export const getPrimaryUserName = () => {
    return getActiveUser().name;
};

export const getPrimaryEmail = () => {
    return getActiveUser().primaryEmail;
};

export const getPrimaryPhone = () => {
    return getActiveUser().primaryPhone;
};

export const getZipcode = () => {
    return getActiveUser().zip;
};

export const isPrivateUser = () => {
    return getActiveUser().roleList.includes('PRIVATE');
};

export const isCommercialUser = () => {
    return getActiveUser().roleList.includes('BUSINESS');
};

export const getCustomerNumbers = () => {
    return getActiveUser()
        .customerIdList.split(',')
        .map((customerId) => customerId.trim());
};

const getActiveUser = () => {
    const activeUser = window.topContext.user.getActiveUser();
    if (activeUser === undefined) {
        throw new Error('Active user from topContext is undefined!');
    }
    return activeUser;
};

export const getSiteConfig = () => {
    const siteConfig = window.topContext.config.getSiteConfig();
    if (siteConfig === undefined) {
        throw new Error('Site config from topContext is undefined!');
    }
    return siteConfig;
};

export const getEndpointConfig = () => {
    const endpointConfig = window.topContext.config.getEndpointConfig();
    if (endpointConfig === undefined) {
        throw new Error('Endpoint config from topContext is undefined!');
    }
    return endpointConfig;
};
